class WysiwygController {
  constructor() {
    this.name = 'wysiwyg';
  }
}

export default WysiwygController;
